<template>
    <v-container class="h-100" v-touch:swipe.left="() => goTo(false)" v-touch:swipe.right="() => goTo(true)">
        <v-carousel progress="primary" hide-delimiters :show-arrows="false" height="100%" v-model="current">
            <v-carousel-item v-for="vocabulary in vocabularies" :key="vocabulary.Text">
                <div class="d-flex justify-center align-center">
                    <v-row height="100%">
                        <v-col cols="12" class="text-center">
                            <v-card class="pa-4">
                                <h1 class="text-center">
                                    {{ vocabulary.Word }}
                                    <ShareButton :words="[vocabulary.Word]" color="default" btnclass="me-3" />
                                </h1>

                                <v-btn color="success" @click="showMeaning = true" v-show="!showMeaning">
                                    {{ $t('pages.reviewVocabulary.showMeaning') }}
                                </v-btn>

                                <v-btn color="success" @click="showMeaning = false" v-show="showMeaning">
                                    {{ $t('pages.reviewVocabulary.hideMeaning') }}
                                </v-btn>

                                <SpeechPlay :text="vocabulary.Word" style="font-size: 25px;" />
                            </v-card>
                        </v-col>

                        <v-col cols="12" v-show="showMeaning">
                            <DetailCard :title="$t('pages.reviewVocabulary.meaning')" :value="vocabulary.Meaning"
                                v-if="vocabulary.Meaning" />
                            <DetailCard :title="$t('pages.reviewVocabulary.example')" :value="vocabulary.Example"
                                v-if="vocabulary.Example" class="mt-2" />
                            <DetailCard :title="$t('pages.reviewVocabulary.description')"
                                :value="vocabulary.Description" v-if="vocabulary.Description" class="mt-2" />

                            <v-card outlined class="pa-4 mt-2">
                                <a class="btn btn-primary" rounded style="margin: auto;display: table;" target="_blank"
                                    :href="`https://www.playphrase.me/#/search?q=${vocabulary.Word}`">
                                    <img src="/images/pplogo.jpg" style="margin-right:8px;">
                                    {{ $t('pages.reviewVocabulary.playPhrase') }}
                                </a>
                            </v-card>

                 
                        </v-col>
                    </v-row>
                </div>
            </v-carousel-item>
        </v-carousel>
    </v-container>

    <v-row class="fixed-bottom d-flex align-center justify-center" no-gutters>
        <v-col cols="6">
            <v-btn color="info" rounded="0" block @click="goTo(false)" style="height: 60px;font-size: x-small;">
                <v-icon size="30" :class="lang.isRtl ? 'ms-1' : 'me-1'">
                    {{ lang.prevIcon }}
                </v-icon>

                {{ $t('pages.reviewVocabulary.prev') }}
            </v-btn>
        </v-col>

        <v-col cols="6">
            <v-btn color="success" rounded="0" block @click="goTo(true)" style="height: 60px;font-size: x-small;">
                {{ $t('pages.reviewVocabulary.next') }}

                <v-icon size="30" :class="lang.isRtl ? 'me-1' : 'ms-1'">
                    {{ lang.nextIcon }}
                </v-icon>
            </v-btn>
        </v-col>

    </v-row>
</template>

<script>
import DetailCard from "@/components/DetailCard";
import ShareButton from "@/components/ShareButton.vue";
import SpeechPlay from "@/components/SpeechPlay";
import { useLangStore } from '@/stores/langStore'

export default {
    name: 'CheckVocabularyPage',
    components: { DetailCard, SpeechPlay, ShareButton },
    data() {
        return {
            current: 0,
            vocabulary: {},
            nvocabulary: {},
            pvocabulary: null,
            showMeaning: false,
            vocabularies: [],
            page: {
                "BoxNumber": this.$route.params.boxNumber ?? 0,
                "SearchText": '',
                "ListLength": 10000,
                "ListPosition": 0
            }
        };
    },
    setup() {
        const lang = useLangStore()
        return { lang }
    },
    methods: {
        async getVocabularies() {
            const response = await this.postRequest('Vocabularies', 'GetVocabularies', this.page);
            this.vocabularies = response.Data.Items.slice().sort(() => Math.random() - 0.5);
            if (this.vocabularies.length > 0 && localStorage.getItem('autoSpeechOnChecking') == 'true')
                this.textToSpeech(this.vocabularies[0].Word);
        },
        goTo(next) {
            if (next) {
                this.current == this.vocabularies.length - 1 ? this.current = 0 : this.current++;
                this.showMeaning = false;
            } else {
                this.current == 0 ? this.current = this.vocabularies.length - 1 : this.current--;
                this.showMeaning = false;
            }
            if (localStorage.getItem('autoSpeechOnChecking') == 'true')
                this.textToSpeech(this.vocabularies[this.current].Word);
        }
    },
    async mounted() {
        await this.getVocabularies();
    },
}
</script>